import Api from './api';

const userService = {
    login: async (params) => {
        const response = await Api.post('/user/login', params);
        localStorage.setItem('user', JSON.stringify(response.data.User));
        localStorage.setItem('nome', response.data.User["nome"]);
        localStorage.setItem('nivel', response.data.User["nivel"]);
        localStorage.setItem('token', response.data.token);
        return response
    },
    logout: () => {
        localStorage.removeItem('user', null)
        localStorage.removeItem('token', null)
        localStorage.removeItem('nome', null)
    },
    cadastro: async (params) => {
        const response = await Api.post('/user/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/user/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/user/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    userEdit: async (id) => {
        const response = await Api.get(`/user/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    senha: async (id, params) => {
        const response = await Api.put(`/user/senha/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/user/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    }
}

export default userService;
